export const TextFeild = ({ textFeildName, placeholder,isAndroid=false }: any) => {
  return (
    <div className="relative z-0">
      <input
        readOnly
        type="text"
        id="floating_standard"
        className={`w-full placeholder-black font-nunito block pt-2.5 pb-1 px-0  text-body1Regular bg-transparent ${isAndroid?"":"border-0 border-b-2  border-gray-100 focus:border-gray-200"}   focus:outline-none placeHolderText   peer`}
        placeholder={placeholder}
      />
      <label
        className="absolute font-nunito text-sideMenuHelpBox transform -translate-y-6  top-3 origin-[0]  labelText"
        contentEditable="false"
      >
        {textFeildName}
      </label>
    </div>
  );
};
